import { createApi } from '@reduxjs/toolkit/query/react';
import { API_URL } from 'constant/Varible';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

// Define a service using a base URL and expected endpoints
export const geoApi = createApi({
  reducerPath: 'geoApi',
  baseQuery: axiosBaseQuery({ baseUrl: API_URL }),
  endpoints: (builder) => ({
    getGeoAddressByPlaceId: builder.query({
      query: ({ placeId }) => ({
        method: 'GET',
        path: `PublicData/search-geocode?placeId=${placeId}`,
      }),
    }),
    getSearchedGeoAddress: builder.query({
      query: ({ input, countryCode }) => ({
        method: 'GET',
        path: `PublicData/search-autocomplete?input=${input}&countryCode=${countryCode}`,
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const geoApiReducerName = geoApi.reducerPath;
export const geoApiReducer = geoApi.reducer;
export const geoApiMiddleware = geoApi.middleware;

export const { useGetGeoAddressByPlaceIdQuery, useGetSearchedGeoAddressQuery } =
  geoApi;
